'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var zod = require('zod');

let MESSAGE_TYPES = /*#__PURE__*/function (MESSAGE_TYPES) {
  MESSAGE_TYPES["READY_FOR_MESSAGES"] = "READY_FOR_MESSAGES";
  MESSAGE_TYPES["INITIAL_DATA"] = "INITIAL_DATA";
  MESSAGE_TYPES["NEW_TOKEN_RESPONSE"] = "NEW_TOKEN";
  MESSAGE_TYPES["NEW_TOKEN_REQUEST"] = "TOKEN_EXPIRED";
  MESSAGE_TYPES["SET_IFRAME_HEIGHT"] = "SET_IFRAME_HEIGHT";
  return MESSAGE_TYPES;
}({});
zod.z.object({
  type: zod.z.literal(MESSAGE_TYPES.READY_FOR_MESSAGES)
});
const initialDataSchema = zod.z.object({
  type: zod.z.literal(MESSAGE_TYPES.INITIAL_DATA),
  payload: zod.z.object({
    orderNumber: zod.z.string().optional(),
    email: zod.z.string().optional(),
    token: zod.z.string().optional(),
    permissions: zod.z.object({
      viewPortal: zod.z.boolean(),
      viewClaim: zod.z.boolean(),
      createClaim: zod.z.boolean(),
      updateClaim: zod.z.boolean()
    })
  })
});
zod.z.object({
  type: zod.z.literal(MESSAGE_TYPES.NEW_TOKEN_REQUEST)
});
const newTokenResponseSchema = zod.z.object({
  type: zod.z.literal(MESSAGE_TYPES.NEW_TOKEN_RESPONSE),
  payload: zod.z.object({
    token: zod.z.string()
  })
});
zod.z.object({
  type: zod.z.literal(MESSAGE_TYPES.SET_IFRAME_HEIGHT),
  payload: zod.z.object({
    height: zod.z.number()
  })
});

exports.MESSAGE_TYPES = MESSAGE_TYPES;
exports.initialDataSchema = initialDataSchema;
exports.newTokenResponseSchema = newTokenResponseSchema;
